
import { reporteStockApi } from "../../apis";
import { useReporteStockStore } from "../../stores/ui/reporteStock.store";

import Swal from "sweetalert2";




export const listadoReporteXStock = async ({ page, id }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('id',  id);

        const { data } = await reporteStockApi.get(`/reportes/xstock`, { params });
        useReporteStockStore.setState({ totalReproteStock : data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const listadoReporteXOPs = async ({ page, id }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('id',  id);

        const { data } = await reporteStockApi.get(`/reportes/xops`, { params });
        useReporteStockStore.setState({ totalReproteStock : data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const crearReporteDeInventario = async (body) => {
    try {
        const { data} = await reporteStockApi.post('/create', body);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}
